<ng-container
  *ngIf="
    params.href && params.routerLinkParams == null;
    then routeWithHref;
    else (params.routerLinkParams && params.href == null && routeLink) ||
      (params.routerLinkParams == null && params.href == null && noRoute)
  "
></ng-container>
<ng-template #routeWithHref>
  <div class="data-table__content">
    <a
      class="data-table__content-link"
      [href]="params.href"
      [target]="params.target ? params.target : '_self'"
    >
      {{ params.value }}
    </a>
  </div>
</ng-template>
<ng-template #routeLink>
  <div class="data-table__content">
    <a
      class="data-table__content-link"
      href="javascript:void(0)"
      [routerLink]="params.routerLinkParams"
      [target]="params.target ? params.target : '_self'"
    >
      {{ params.value }}
    </a>
  </div>
</ng-template>
<ng-template #noRoute>
  <div class="data-table__content">
    <a
      class="data-table__content-link"
      href="javascript:void(0)"
      [routerLink]="null"
      [target]="params.target ? params.target : '_self'"
    >
      {{ params.value }}
    </a>
  </div>
</ng-template>
